import { PlusIcon } from '@heroicons/react/24/outline';

import { AppButton, ButtonLoader, TAppButtonOptions } from '../forms';

interface IHeadingProps {
  description?: string;
  isLoadingContent?: boolean;
  mainCTA?: TAppButtonOptions;
  title?: string;
}

/**
 * -----------------------------------------------------------------------------
 * It render a title and a description text.
 *
 * TODO: add the breadcrumbs navigation to the dashboard.
 */
export function Heading({
  description,
  isLoadingContent,
  mainCTA,
  title,
}: Readonly<IHeadingProps>) {
  return (
    <div className="flex flex-row justify-between gap-4 px-6 py-4">
      <div className="flex flex-col gap-0">
        {title ? (
          <h2 className="pb-1 text-2xl font-medium leading-none">{title}</h2>
        ) : null}
        {description ? (
          <p className="leading-2 pt-1 text-xs text-gray-600">{description}</p>
        ) : null}
      </div>

      <div className="flex items-center gap-2 sm:gap-6">
        {mainCTA ? (
          <AppButton
            {...mainCTA}
            iconStart={mainCTA.iconStart || <PlusIcon />}
          />
        ) : null}

        {isLoadingContent ? (
          <ButtonLoader className="h-6 w-6" isEnabled />
        ) : null}
      </div>
    </div>
  );
}
